
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import api from '../../api';

export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
});
},
components: {
Group,
XInput,
XButton,
PopupPicker,
},
mounted() {
},
activated() {
},
watch: {
},
data() {
return {
formData: {
carVan: [],
carLength: [],
count: '',
},
optionsCarVan: [],
optionsLength: [],
};
},
computed: {
allDic() {
return this.$store.state.allDic;
},
getCarVan() {
if (this.allDic['carVan']) {

const carVan = JSON.parse(JSON.stringify(this.allDic['carVan'].children));
const arr = carVan.map((item) => {
item.name = item.value;
item.value = item.id;
return item;
});
return [arr];
}
},
getLength() {
if (this.allDic['carLength']) {
const carVan = JSON.parse(JSON.stringify(this.allDic['carLength'].children));;
const arr = carVan.map((item) => {
item.name = `${item.value}米`;
item.value = item.id;
return item;
});
return [arr];
}
},
},
methods: {
save() {
const {carVan, carLength, count} = this.formData;
const param = {
carVan: carVan[0],
carLength: carLength[0],
count,
};
if(carVan[0] === '' || carLength[0] === '' || count === '') {
this.$vux.toast.text('请完善信息');
} else {
api.vega.company.updateCompanyTruck(param).then((res) => {
const code = res.data;
if (code.code === 0 && code.sub_code === 0) {
this.$vux.toast.text('保存成功');
this.$router.go(-1);
}
});
}
},






},
};
